import { render, staticRenderFns } from "./InvestorDetailsModal.vue?vue&type=template&id=f78d8140&scoped=true"
import script from "./InvestorDetailsModal.vue?vue&type=script&lang=js"
export * from "./InvestorDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./InvestorDetailsModal.vue?vue&type=style&index=0&id=f78d8140&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78d8140",
  null
  
)

export default component.exports